import "./Technologies.css";

// Import all images
import javascriptIcon from "../../../assets/icons/JavaScript.png";
import htmlIcon from "../../../assets/icons/html.png";
import cssIcon from "../../../assets/icons/css.png";
import figmaIcon from "../../../assets/icons/Figma.png";
import miroIcon from "../../../assets/icons/Miro.png";
import trelloIcon from "../../../assets/icons/Trello.png";
import blenderIcon from "../../../assets/icons/Blender.png";
import vsIcon from "../../../assets/icons/Visual Studio.png";
import cppIcon from "../../../assets/icons/C++.png";
import reactIcon from "../../../assets/icons/React.png";
import goIcon from "../../../assets/icons/Go.png";
import rubyIcon from "../../../assets/icons/Ruby.png";
import phpIcon from "../../../assets/icons/Php.png";
import javaIcon from "../../../assets/icons/Java.png";
import pythonIcon from "../../../assets/icons/Python.png";
import sublimeIcon from "../../../assets/icons/Simlime Text.png";
import nodejsIcon from "../../../assets/icons/NodeJs.png";
import gitIcon from "../../../assets/icons/Git.png";

const technologyGroups = [
  {
    title: "Дизайн и инструменты разработки",
    icons: [
      { src: figmaIcon, alt: "Figma" },
      { src: vsIcon, alt: "Visual Studio" },
      { src: sublimeIcon, alt: "Sublime Text" },
      { src: miroIcon, alt: "Miro" },
      { src: trelloIcon, alt: "Trello" },
      { src: blenderIcon, alt: "Blender" },
    ],
  },
  {
    title: "Фронтенд и веб-технологии",
    icons: [
      { src: javascriptIcon, alt: "JavaScript" },
      { src: htmlIcon, alt: "HTML" },
      { src: cssIcon, alt: "CSS" },
      { src: reactIcon, alt: "React" },
      { src: nodejsIcon, alt: "Node.js" },
      { src: gitIcon, alt: "Git" },
    ],
  },
  {
    title: "Бэкенд и языки программирования",
    icons: [
      { src: pythonIcon, alt: "Python" },
      { src: phpIcon, alt: "PHP" },
      { src: javaIcon, alt: "Java" },
      { src: cppIcon, alt: "C++" },
      { src: goIcon, alt: "Go" },
      { src: rubyIcon, alt: "Ruby" },
    ],
  },
];

const Technologies = () => {
  return (
    <div className="technologies-container">
      <h2 className="technologies-title">
        Технологии, <br /> которые мы используем
      </h2>

      <div className="technologies-grid">
        {technologyGroups.map((group, index) => (
          <div key={index} className="technology-group">
            <h3 className="group-title">{group.title}</h3>
            <div className="icon-card">
              <div className="icon-grid">
                {group.icons.map((icon, i) => (
                    <img
                      src={icon.src || "/placeholder.svg"}
                      alt={icon.alt}
                      className="icon-image"
                    />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Technologies;
